export const PROJECT_BASE_PATH = '/:entityName/:projectName';

export const PROJECT_RUNS_TABLE_PATH = `${PROJECT_BASE_PATH}/table`;

export const FULL_SCREEN_WORKSPACE_PANEL_PATH = `${PROJECT_BASE_PATH}/panel/:panelId`;
export const FULL_SCREEN_WORKSPACE_TAB_PANEL_PATH = `${PROJECT_BASE_PATH}/:tab(workspace)/panel/:panelId`;

export const EMBEDDED_WORKPACE_PANEL_PATH = `${PROJECT_BASE_PATH}/embed/panel/:panelId`;
/**
 * PROJECT_BASE_PATH also lands on the the project workspace,
 * and is actually the more commonly used URL for it. This
 * `/workspace` subpath is extraneous, but has been around for a
 * long time and may be saved/bookmarked/shared by users,
 * so we must keep it for legacy purposes.
 */
export const PROJECT_WORKSPACE_PATH = `${PROJECT_BASE_PATH}/:tab(workspace)`;

export const PROJECT_WORKSPACE_PATHS = [
  PROJECT_BASE_PATH,
  PROJECT_WORKSPACE_PATH,
  FULL_SCREEN_WORKSPACE_PANEL_PATH,
  FULL_SCREEN_WORKSPACE_TAB_PANEL_PATH,
  EMBEDDED_WORKPACE_PANEL_PATH,
];
